var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.09862C14.9985 7.3099 14.9291 7.51509 14.802 7.6839C14.6749 7.85272 14.497 7.9762 14.2944 8.03612L9.50936 9.50862L8.03686 14.2936C7.97685 14.4962 7.85334 14.6741 7.68455 14.8011C7.51576 14.9282 7.31061 14.9976 7.09936 14.9992H7.08061C6.87345 15.0012 6.67094 14.9378 6.50186 14.8181C6.33278 14.6984 6.20572 14.5284 6.13873 14.3324L2.06248 3.33799C2.06116 3.33475 2.06012 3.33141 2.05936 3.32799C1.99842 3.15102 1.98838 2.96049 2.03038 2.77808C2.07237 2.59568 2.16472 2.42872 2.29691 2.29621C2.4291 2.16369 2.59583 2.07093 2.77813 2.02849C2.96043 1.98605 3.15098 1.99562 3.32811 2.05612L3.33811 2.05924L14.3331 6.13799C14.5322 6.20604 14.7043 6.33598 14.8243 6.50881C14.9443 6.68164 15.0058 6.88831 15 7.09862Z",
    fill: "#148E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovingIcon);
export default __webpack_public_path__ + "static/media/movingIcon.f47bcbccf2421888c91b54183ae8300f.svg";
export { ForwardRef as ReactComponent };